import { COMMUNITIES_ACCESS_LEVELS } from '../../constants';
import { COMMUNITY_ACCESS_READ_ONLY } from '../../constants/strings';

// returns only read only string or empty string otherwise
export default (accessLevel, formatMessage) => {
  if (accessLevel === COMMUNITIES_ACCESS_LEVELS.READ_ONLY) {
    return formatMessage(COMMUNITY_ACCESS_READ_ONLY);
  }

  if (accessLevel === COMMUNITIES_ACCESS_LEVELS.READ_AND_POST_WITH_APPROVAL) {
    return formatMessage({ id: 'community.access.withApproval' });
  }

  return formatMessage({ id: 'community.access.readAndPost' });
};



// WEBPACK FOOTER //
// ./src/utils/communities/getCommunityAccessType.js